import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useState, useEffect } from 'react';
import { useSession as useBetterAuthSession } from '../../api/auth';
const AuthContext = createContext({
    session: null,
    isPending: true,
    error: null,
});
export function AuthProvider({ children }) {
    const betterAuth = useBetterAuthSession();
    const [initialSession, setInitialSession] = useState(null);
    const [initialCheckDone, setInitialCheckDone] = useState(false);
    // Explicit initial session check — avoids Better Auth nanostore race condition
    useEffect(() => {
        fetch('/api/auth/get-session', { credentials: 'include' })
            .then((r) => r.ok ? r.json() : null)
            .then((data) => {
            if (data?.session) {
                setInitialSession(data);
            }
        })
            .catch(() => { })
            .finally(() => setInitialCheckDone(true));
    }, []);
    // Once Better Auth store has data, use it as the source of truth
    const session = betterAuth.data ?? initialSession ?? null;
    const isPending = !initialCheckDone && !betterAuth.data;
    return (_jsx(AuthContext.Provider, { value: { session, isPending, error: betterAuth.error }, children: children }));
}
export function useAuth() {
    return useContext(AuthContext);
}
